export default "__VITE_ASSET__B8dtxF_C__"